import { Component, input } from '@angular/core';
import { TaskTimeReportsComponent } from '@app/components/task/task-state-selectors/task-time-reports/task-time-reports.component';
import { Task } from '@app/shared/types/models/task/task.model';

/**
 * @summary Task detail Time reports tab — lazy-mounted wrapper around task-time-reports.
 * @selector proffeo-task-details-time-reports-tab
 */
@Component({
  selector: 'proffeo-task-details-time-reports-tab',
  templateUrl: './task-details-time-reports-tab.component.html',
  imports: [TaskTimeReportsComponent]
})
export class TaskDetailsTimeReportsTabComponent {
  public readonly task = input.required<Task>();
  public readonly isActive = input.required<boolean>();
}
